(function () {
    'use strict';

    angular.module("imApp").factory("choiceProdPriceGrpService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1201,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1202,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 1203,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
